import { isUndefined, isNull } from 'lodash';
import { InputValidationRule } from 'vuetify';

export const numericValidator: InputValidationRule = (value: unknown) => {
  if (
    isUndefined(value) ||
    isNull(value) ||
    (Array.isArray(value) && value.length === 0) ||
    value === false
  ) {
    return true;
  }

  return (
    /^[+-]?\d+(\.\d+)?$/.test(String(value)) || 'This value must be a number'
  );
};

export const requiredValidator: InputValidationRule = (value: unknown) => {
  if (
    isUndefined(value) ||
    isNull(value) ||
    (Array.isArray(value) && value.length === 0) ||
    value === false
  )
    return 'This field is required';

  return !!String(value).trim().length || 'This field is required';
};

export const percentageValidator: (
  min?: number,
  max?: number
) => InputValidationRule = (min = 0, max) => (value: unknown) => {
  if (
    !(
      isUndefined(value) ||
      isNull(value) ||
      (Array.isArray(value) && value.length === 0) ||
      value === false
    )
  ) {
    if (isNaN(Number(value))) {
      return 'This value is not a number';
    }

    const numValue = Number(value);
    const effectiveMax = isNull(max) || isUndefined(max) ? Infinity : max;

    return (
      (numValue >= min && numValue <= effectiveMax) ||
      `This value must be between ${min} and ${
        isFinite(effectiveMax) ? effectiveMax : '∞'
      }`
    );
  }
  return true;
};
